import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ProjectAttachmentFilters } from '../../../commons/models/project-attachment.model';

@Component({
  selector: 'app-project-attachment-filters',
  templateUrl: './project-attachment-filters.component.html',
  styleUrls: ['./project-attachment-filters.component.scss']
})
export class ProjectAttachmentFiltersComponent {


  @Output()
  onFilter: EventEmitter<ProjectAttachmentFilters> = new EventEmitter();

  private _defaultFilters: ProjectAttachmentFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getProjectAttachmentFilters());
  }

  private _getProjectAttachmentFilters(): ProjectAttachmentFilters {
    let filters: ProjectAttachmentFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): ProjectAttachmentFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: ProjectAttachmentFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
